package com.eladfinish.bible.contest.screens.search.usecases.specialSearch

import com.eladfinish.bible.contest.screens.search.model.ChapterDetails
import dev.icerock.moko.resources.desc.StringDesc

// statistics in the bible:
// number of verses in each chapter. e.g. bereshit: [31,25,24,26,32,...]
// total number of verses in a book
// number of words in each chapter/parasha/book
// the longest word in each chapter/parasha/book
// number of letters in each chapter/parasha/book

data class SearchFact(
    val searchProvider: () -> SpecialSearch,
    val stringDesc: StringDesc,
    val extraData: String? = null,
    val shouldShowAsList: Boolean = false,
) {
    companion object {
        fun String.plusExtraData(searchFact: SearchFact): String =
            plus(searchFact.extraData?.let { data -> " $data" }.orEmpty())
    }
}

interface SpecialSearch {
    fun process(chapterDetails: ChapterDetails)
    fun getSummary(): String
    fun provideItems(): List<SpecialSearchItem> = emptyList()
    fun isOnlyTorah(): Boolean = false
}

data class SpecialSearchItem(
    val content: String,
    val book: String,
    val chapter: String,
    val verse: String,
)
